import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../CommonLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import "./settings.css";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";

const ReportSettings = () => {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [faqData, setfaqData] = useState("2");
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [cardmsg, setCardmsg] = useState([]);
  const [loading, Setloading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [cronStatus, setCronStatus] = useState(false);
  const [freesiteaudit, setfreesiteaudit] = useState({ status: true, error: "" });

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const ReportcronsStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}settings/get_domain_automatic_report_status/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: { Authorization: `${ApiToken}` },
        }
      );

      if (response?.data?.cron_status !== undefined) {
        setCronStatus(response.data.cron_status);
      }

      if (response?.data?.message) {
        setCardmsg(response.data.message);
        setOpen(true);
      }
    } catch (error) {
      if ([599, 500, 400, 404].includes(error?.response?.status)) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error);
      } else if (error?.code === "ERR_NETWORK") {
        navigate("/errorpages");
      }
    }
  };

  const freeAudit = async () => {
    const check = await Utils("report_settings", ApiToken);
    setfreesiteaudit(check);
    if (check.status) {
      ReportcronsStatus();
    }
  }

  useEffect(() => {
    freeAudit();
    faqdatafun();
  }, []);



  const SaveReportcronsStatus = async (e) => {
    Setloading(true);
    try {
      const datavalue = await axios.post(
        `${process.env.REACT_APP_API_URL}settings/set_domain_automatic_report_status/`,
        {
          user_domain_id: esodata.domaindata.value.header_selected,
          cron_status: cronStatus
        },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      Setloading(false);
      if (datavalue?.data) {
        setCardmsg(datavalue?.data?.message)
        setOpen(true);
      }
    } catch (err) {
      Setloading(false);
      console.log(err);
    }
  };

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=66`;

    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Report Settings</title>
      </Helmet>
      <div className={`over_all_container user_experieceover_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {loading === true ? <Loader /> : null}

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Report Settings
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Settings' },
                        { title: 'Report Settings', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
         <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid" style={{ padding: "40px 0", background: "#fff!important" }}>
                <Grid item xs={12} md={12}>
                  <div className="cnt_audit_outer_wrap">
                    {freesiteaudit.status ?
                      <div className="user_experince_form_container_wraps">
                        <div className="user_experince_form_container link_checker_settings cron_checkbox_center">
                          <div className="form_row internal_form_settings cron_checkbox" >
                            <div className=" cron_checkbox">
                              <div className="">
                                <h3 style={{ color: "#ff601f" }} className="correction_input_header">Enable Automatic Weekly Reports</h3>
                              </div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={cronStatus}
                                    onChange={(e) => setCronStatus(e.target.checked)}
                                    sx={{
                                      color: "#0b2033",
                                      '&.Mui-checked': {
                                        color: "#ff601f",
                                      }
                                    }}
                                  />
                                }
                                label="Enable Automatic Weekly Reports"
                              />

                              <div><button
                                className="btn_dashboard"
                                onClick={SaveReportcronsStatus}
                              >Save
                              </button></div>
                            </div>
                          </div>
                        </div>
                      </div> : <Freeaudit planStatus={freesiteaudit} />
                    }
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>


         <Container maxWidth={false} className="footer-container footor-bottom-fixed">
            <Box className="footer-box">
              <Grid container className="footer-grid">
                <Grid item xs={12} md={6}>
                  <div className="footer-left">
                    <p className="footer-text">
                      All Rights Reserved Copyright © 2025 |
                      <a href="https://www.egrovesys.com/" target="_blank"> <span className="footer-brand"> eGrove System</span></a>
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="footer-right">
                    <p>{/* Add content if needed */}</p>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>



        <div className="cnt_audit_outer_wrap">
          {/* <div className="top_breadcrumb_menu">
            <CommonBreadCrumb breadcrumbValue={[
              { title: 'Settings' },
              { title: 'Report Settings', activeColor: true }
            ]} />

            <div className="exportpdf_outer">
              <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
                <QuestionMarkIcon />

              </button>

            </div>
            {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

          </div> */}

          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle className="keyword-dialog-header">{"Alert Message "}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {cardmsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-button">
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
          {!openCommonAlerts &&

            <CommonErrorAlert
              data={{
                apiopen: apiopen,
                apiErrorMsg: apierrorMsg,
                isIconStyled: true
              }}
              closeAlert={apihandleClose} />
          }
          <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />

      

         

         

          {/* {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

          <div className="cnt_hdr_top_wraps">
            <div className="cnt_hdr_top_lft_wrap">
              <h2 className="heading_font"> Report Settings</h2>
            </div>
          </div>

          {freesiteaudit.status ?
            <div className="user_experince_form_container_wraps">
              <div className="user_experince_form_container link_checker_settings cron_checkbox_center">
                <div className="form_row internal_form_settings cron_checkbox" >
                  <div className=" cron_checkbox">
                    <div className="">
                      <h3 style={{ color: "#ff601f" }} className="correction_input_header">Enable Automatic Weekly Reports</h3>
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={cronStatus}
                          onChange={(e) => setCronStatus(e.target.checked)}
                          sx={{
                            color: "#0b2033",
                            '&.Mui-checked': {
                              color: "#ff601f",
                            }
                          }}
                        />
                      }
                      label="Enable Automatic Weekly Reports"
                    />

                    <div><button
                      className="run_rpt_btn rn_rpt_btn over_all_accessibility runreportnew btn_cron_checkbox"
                      onClick={SaveReportcronsStatus}
                    >Save
                    </button></div>
                  </div>
                </div>
              </div>
            </div> : <Freeaudit planStatus={freesiteaudit} />
          } */}
        </div>


        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />

      </div>
    </>
  );
};

export default ReportSettings;
